module.exports = __webpack_public_path__ + "static/media/dashboard_menu_en.7f1f17ef.png";